var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,9.4l-10-8.2C17.6,0.4,16.3,0,15,0s-2.6,0.4-3.5,1.2l-10,8.2c-1.9,1.5-1.9,4-0.2,5.6c-1.8,1.6-1.7,4.1,0.2,5.6l10,8.2 c0.9,0.8,2.2,1.2,3.5,1.2c1.3,0,2.6-0.4,3.5-1.2l10-8.2c0.9-0.8,1.5-1.8,1.5-2.9c0-1-0.5-2-1.3-2.8C30.5,13.4,30.4,10.9,28.5,9.4z  M2.2,10l10-8.2c0.7-0.6,1.7-0.9,2.8-0.9s2.1,0.3,2.8,0.9l10,8.2c1.5,1.3,1.5,3.3,0,4.6l-10,8.2c-0.7,0.6-1.7,0.9-2.8,0.9 s-2.1-0.3-2.8-0.9l-10-8.2C0.7,13.3,0.7,11.2,2.2,10z M27.8,20l-10,8.2c-0.7,0.6-1.7,0.9-2.8,0.9s-2.1-0.3-2.8-0.9L2.2,20 c-1.5-1.2-1.5-3.2-0.2-4.4l9.4,7.7c0.9,0.8,2.2,1.2,3.5,1.2s2.6-0.4,3.5-1.2l9.4-7.7c0.6,0.6,1,1.3,1,2.1 C29,18.6,28.5,19.4,27.8,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.23e0ca3f8530103790e275768d03d413.svg";
export { ForwardRef as ReactComponent };